var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "headers" }, [
    _c("img", {
      staticClass: "headers-icon-left",
      attrs: { src: _vm.heard_left },
      on: { click: _vm.goTo },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "headers-title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "headers-border" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }